import React from "react";
import { Routes, Route } from "react-router-dom"; 
import ProductsList from "./products-list";
import ProductsDetail from "./products-detail";

//
const Products = () => {
  return (
    <React.Fragment>
      <Routes>
        <Route path="" element={<ProductsList />} />
        <Route path="/" element={<ProductsList />} />
         <Route path="/v/:url" element={<ProductsDetail />} />
        {/*<Route path="/c/:catId" element={<ProductsCategory />} /> */}
      </Routes>
    </React.Fragment>
  );
};

export default Products;
